'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var exporter = require('ipfs-unixfs-exporter');

var errCode = require('err-code');

var _require = require('../utils'),
    normalizeCidPath = _require.normalizeCidPath,
    mapFile = _require.mapFile;

module.exports = function (_ref) {
  var ipld = _ref.ipld,
      preload = _ref.preload;
  return /*#__PURE__*/function () {
    var _ls = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ipfsPath, options) {
      var path, recursive, pathComponents, file, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, child, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, _child;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              path = normalizeCidPath(ipfsPath);
              recursive = options.recursive;
              pathComponents = path.split('/');

              if (options.preload !== false) {
                preload(pathComponents[0]);
              }

              _context.next = 7;
              return _awaitAsyncGenerator(exporter(ipfsPath, ipld, options));

            case 7:
              file = _context.sent;

              if (file.unixfs) {
                _context.next = 10;
                break;
              }

              throw errCode(new Error('dag node was not a UnixFS node'), 'ERR_NOT_UNIXFS');

            case 10:
              if (!(file.unixfs.type === 'file')) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", mapFile(file, options));

            case 12:
              if (!file.unixfs.type.includes('dir')) {
                _context.next = 88;
                break;
              }

              if (!recursive) {
                _context.next = 51;
                break;
              }

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 16;
              _iterator = _asyncIterator(exporter.recursive(file.cid, ipld, options));

            case 18:
              _context.next = 20;
              return _awaitAsyncGenerator(_iterator.next());

            case 20:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 24;
              return _awaitAsyncGenerator(_step.value);

            case 24:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 34;
                break;
              }

              child = _value;

              if (!(file.cid.toBaseEncodedString() === child.cid.toBaseEncodedString())) {
                _context.next = 29;
                break;
              }

              return _context.abrupt("continue", 31);

            case 29:
              _context.next = 31;
              return mapFile(child, options);

            case 31:
              _iteratorNormalCompletion = true;
              _context.next = 18;
              break;

            case 34:
              _context.next = 40;
              break;

            case 36:
              _context.prev = 36;
              _context.t0 = _context["catch"](16);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 40:
              _context.prev = 40;
              _context.prev = 41;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 45;
                break;
              }

              _context.next = 45;
              return _awaitAsyncGenerator(_iterator.return());

            case 45:
              _context.prev = 45;

              if (!_didIteratorError) {
                _context.next = 48;
                break;
              }

              throw _iteratorError;

            case 48:
              return _context.finish(45);

            case 49:
              return _context.finish(40);

            case 50:
              return _context.abrupt("return");

            case 51:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _context.prev = 53;
              _iterator2 = _asyncIterator(file.content());

            case 55:
              _context.next = 57;
              return _awaitAsyncGenerator(_iterator2.next());

            case 57:
              _step2 = _context.sent;
              _iteratorNormalCompletion2 = _step2.done;
              _context.next = 61;
              return _awaitAsyncGenerator(_step2.value);

            case 61:
              _value2 = _context.sent;

              if (_iteratorNormalCompletion2) {
                _context.next = 71;
                break;
              }

              _child = _value2;
              _child = mapFile(_child, options);
              _child.depth--;
              _context.next = 68;
              return _child;

            case 68:
              _iteratorNormalCompletion2 = true;
              _context.next = 55;
              break;

            case 71:
              _context.next = 77;
              break;

            case 73:
              _context.prev = 73;
              _context.t1 = _context["catch"](53);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t1;

            case 77:
              _context.prev = 77;
              _context.prev = 78;

              if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                _context.next = 82;
                break;
              }

              _context.next = 82;
              return _awaitAsyncGenerator(_iterator2.return());

            case 82:
              _context.prev = 82;

              if (!_didIteratorError2) {
                _context.next = 85;
                break;
              }

              throw _iteratorError2;

            case 85:
              return _context.finish(82);

            case 86:
              return _context.finish(77);

            case 87:
              return _context.abrupt("return");

            case 88:
              throw errCode(new Error("Unknown UnixFS type ".concat(file.unixfs.type)), 'ERR_UNKNOWN_UNIXFS_TYPE');

            case 89:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[16, 36, 40, 50], [41,, 45, 49], [53, 73, 77, 87], [78,, 82, 86]]);
    }));

    function ls(_x, _x2) {
      return _ls.apply(this, arguments);
    }

    return ls;
  }();
};